import React from "react";

const MonthSelect = ({
  selectedMonth,
  selectedMonthName,
  months,
  onChange,
  name = "selectedMonth",
  className = "col-sm-3",
}) => (
  <div className={className}>
    <select
      className="form-select"
      name={name}
      value={selectedMonth || ""}
      onChange={onChange}
    >
      <option value="" disabled={!!(selectedMonth || selectedMonthName)}>
        Select Month
      </option>
      <option value="AllMonths">All Months</option>
      {months.map((month, index) => (
        <option key={index} value={JSON.stringify(month.tran_date)}>
          {month.name}
        </option>
      ))}
    </select>
  </div>
);

export default MonthSelect;
